import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from '../../../Spinner.gif';
import { Toast, ToastContainer } from 'react-bootstrap';



function AppointmentAdmin() {




    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");





    const tableStyle = { border: '1px solid #dee2e6' };

    const [apiResponse, setApiResponse] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [filterRange, setFilterRange] = useState('all'); // Filter by date range
    const [modalData, setModalData] = useState({ message: '', name: '' });
    const [isModalOpen, setIsModalOpen] = useState(false);



    // Fetch data from API
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch('https://sbk-backend.vercel.app/get-all-appointments');
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const result = await response.json();
                
                setApiResponse(result);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);


console.log("apiResponse==================?",apiResponse)


    // Handle modal
    const handleOpenModal = (name, message) => {
        setModalData({ name, message });
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };







    return (
        <div>
            <h3 className="d-flex justify-content-around">Admin Table - Appointment</h3>



            <table className="table table-striped" style={tableStyle}>
                <thead className="thead-dark">
                    <tr>

                        <th>#</th>
                        <th>Name</th>
                        {/* <th>Last Name</th> */}
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Appointment Time</th>
                        <th>Appointment Date</th>
                        <th>Message</th>
                        <th>Submitted At</th>
                        <th>Service</th>
                        
                    </tr>
                </thead>
                <tbody>
                    {apiResponse.
                        sort((a, b) => new Date(b.submittedAt) - new Date(a.submittedAt))
                        .map((item, index) => (
                            <tr key={item._id}>

                                <td>{index + 1}</td>
                                <td>{`${item.firstName} ${item.lastName}`}</td>
                                <td>{item.email}</td>
                                <td>{item.mobile}</td>
                                <td>{item.appointmentTime}</td>
                                <td>{new Date(item.appointmentDate).toLocaleString()}</td>
                                <td>
                                    {item.message.length > 50 ? (
                                        <>
                                            {`${item.message.substring(0, 50)}...`}
                                            <button
                                                onClick={() =>
                                                    handleOpenModal(`${item.firstName} ${item.lastName}`, item.message)
                                                }
                                                className="btn btn-link p-0"
                                            >
                                                Read More
                                            </button>
                                        </>
                                    ) : (
                                        item.message
                                    )}
                                </td>
                                <td>{new Date(item.submittedAt).toLocaleString()}</td>
                                <td>{item.service}</td>

                            </tr>
                        ))}
                </tbody>
            </table>




            {/* Modal */}
            {isModalOpen && (
                <div
                    className="modal show d-block"
                    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Message from {modalData.name}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>{modalData.message}</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCloseModal}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            <ToastContainer position="top-end" className="p-3">
                <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Action Status</strong>
                        <small>Just now</small>
                    </Toast.Header>
                    <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>


        </div>
    );
}

export default AppointmentAdmin;
